export default __webpack_public_path__ + "static/media/mom.240095a2.mp4";